import { Component } from '@angular/core'

@Component({
  selector: 'cover-account-dashboard',
  templateUrl: './account-dashboard.component.html',
  styleUrls: ['./account-dashboard.component.scss'],
})
export class AccountDashboardComponent {
  // customer$: Observable<CustomerInformationState>
  //
  // constructor(private readonly store: Store) {
  //   this.customer$ = store.select(selectProfileState.customerInformationState)
  // }
}
